import { WarningCard } from "./WarningCard";

export default WarningCard;
